import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { mutationKeys } from '../mutationKeys';
import { AxiosError } from 'axios';

export interface GenerateEventPdfResponse {
  public_share_link: string;
  download_url: string;
}

const generateEventPdf = async (uuid: string) => {
  const response = await CustomAxios.post(`/events/${uuid}/generate_pdf`);
  return response.data as GenerateEventPdfResponse;
};

interface UseGenerateEventPdfProps {
  uuid: string;
  onSuccessCallback?: (data: GenerateEventPdfResponse) => void;
  onErrorCallback?: (error: string) => void;
}
export function useGenerateEventPdf({ uuid, onSuccessCallback, onErrorCallback }: UseGenerateEventPdfProps) {
  return useMutation({
    mutationKey: [mutationKeys.generateEventPdf, uuid],
    mutationFn: () => generateEventPdf(uuid),
    onSuccess: (data: GenerateEventPdfResponse) => {
      onSuccessCallback?.(data);
    },
    onError: (error: AxiosError<{ error?: string }>) => {
      onErrorCallback?.(error.response?.data?.error || 'Failed to generate PDF');
    },
  });
}
